module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('square-grid')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('header', [_c('app-header')], 1), _vm._v(" "), _c('main', [_c('router-view')], 1), _vm._v(" "), _c('footer', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../src/assets/img/logo-powerby-luxtag.png")
    },
    on: {
      "click": function($event) {
        return _vm.link()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348407aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 254
// module chunks = 11